import { Injectable } from '@angular/core';
import { OutcomeActionType } from '../models/outcomes/OutcomeActionType';
import { ApiOutcomeActionsService } from '../api-services/outcome-actions.api.service';

@Injectable({
  providedIn: 'root'
})
export class OutcomeActionTypeService {

  public types: OutcomeActionType[] = [];
  constructor(private outcomeActionApiService: ApiOutcomeActionsService) {
    this.getOutcomeActionTypes();
   }

  getType(OutcomeActionTypeId: number): string {
    return this.types.filter(s => s.outcomeActionTypeId == OutcomeActionTypeId)[0].type;
  }

  getId(actionType: string): number {
    return this.types.filter(s => s.type == actionType)[0].outcomeActionTypeId;
  }

  getOutcomeActionTypes(){
    this.outcomeActionApiService.getOutcomeActionTypes().subscribe(outcomeActionTypes => {
      this.types = outcomeActionTypes;
    });
  }
}